import { CUSTOMER_ROLE_SLUG } from 'config/app.config';
import { getUserInfo } from 'helpers/StorageHelper';
import { type PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { store } from 'store';
import { logoutUserState } from 'store/auth/slices/AuthSlice';

import { getAdminUserHomePageRoute, loginRoutes } from './admin/AdminRoutes';
import { customerAuthRoutes } from './customer/CustomerRoutes';

const PASSWORD_RESET_PATHS = [
  loginRoutes.resetPassword.path,
  customerAuthRoutes.createPassword.path,
];

const PublicRoute = ({ children }: PropsWithChildren) => {
  const userInfo: any = getUserInfo();
  const location = useLocation();
  if (userInfo) {
    if (userInfo?.selected_role?.slug != CUSTOMER_ROLE_SLUG) {
      if (PASSWORD_RESET_PATHS.includes(location.pathname)) {
        store.dispatch(logoutUserState());
        return children;
      }
      return <Navigate to={getAdminUserHomePageRoute()} replace />;
    }
    return children;
  } else {
    return children;
  }
};
export default PublicRoute;
